{
  "toast": {
    "created": "Quiz criado com sucesso!",
    "createError": "Erro ao criar quiz",
    "updated": "Quiz atualizado com sucesso!",
    "updateError": "Erro ao atualizar quiz",
    "deleted": "Quiz removido com sucesso!",
    "deleteError": "Erro ao remover quiz",
    "started": "Quiz iniciado!",
    "startError": "Erro ao iniciar quiz",
    "passed": "Parabéns! Você passou com {{score}}%!",
    "failed": "Você obteve {{score}}%. Tente novamente!",
    "submitError": "Erro ao submeter quiz"
  },
  "questionType": {
    "multipleChoice": "Múltipla Escolha",
    "trueFalse": "Verdadeiro/Falso",
    "essay": "Dissertativa"
  },
  "player": {
    "questionNumber": "Questão {{number}}",
    "points": "{{points}} pts",
    "hint": "Dica:",
    "previous": "Anterior",
    "submitting": "Enviando...",
    "finish": "Finalizar Quiz",
    "next": "Próxima",
    "answeredCount": "Respondidas: <highlight>{{answered}}</highlight> de {{total}}",
    "passingScore": "Nota mínima: <highlight>{{score}}%</highlight>",
    "exit": "Sair do Quiz"
  },
  "results": {
    "passedTitle": "Parabéns!",
    "failedTitle": "Continue Tentando!",
    "passedDescription": "Você passou no quiz com sucesso!",
    "failedDescription": "Não desista! Revise o conteúdo e tente novamente.",
    "yourScore": "Sua Nota",
    "passingScore": "Nota Mínima",
    "correct": "Acertos",
    "wrong": "Erros",
    "accuracy": "Precisão",
    "time": "Tempo",
    "completedAt": "Concluído em {{date}}",
    "completedAtFormat": "dd 'de' MMMM 'de' yyyy 'às' HH:mm",
    "review": "Revisão das Questões",
    "answerCorrect": "Correto",
    "answerIncorrect": "Incorreto",
    "pointsOf": "{{points}}/{{total}} pts",
    "explanation": "Explicação:",
    "backToCourse": "Voltar ao Curso",
    "viewCertificate": "Ver Certificado",
    "retry": "Tentar Novamente",
    "retryInfo": "Você pode tentar novamente. Limite de tentativas: {{max}}",
    "noRetries": "⚠️ Não é possível tentar novamente. Revise o conteúdo do curso."
  },
  "studentPlayer": {
    "timeUp": "Tempo esgotado! Enviando respostas...",
    "starting": "Iniciando quiz...",
    "loadError": "Erro ao carregar o quiz",
    "reloadHint": "Tente recarregar a página",
    "questionOf": "Questão {{number}} de {{total}}",
    "answered_one": "{{count}} respondida",
    "answered_zero": "{{count}} respondidas",
    "answered_other": "{{count}} respondidas",
    "progress": "Progresso",
    "question": "Questão {{number}}",
    "points_one": "{{count}} ponto",
    "points_zero": "{{count}} pontos",
    "points_other": "{{count}} pontos",
    "yourAnswer": "Sua resposta:",
    "answerPlaceholder": "Digite sua resposta aqui...",
    "essayHint": "Seja detalhado em sua resposta. Questões dissertativas são avaliadas manualmente.",
    "previous": "Anterior",
    "answeredOf": "{{answered}}/{{total}} questões respondidas",
    "next": "Próxima",
    "finish": "Finalizar Quiz",
    "instructions": "Instruções",
    "timeAlmostUp": "Tempo quase esgotado!",
    "timeRemaining": "Restam apenas {{time}}"
  },
  "studentResults": {
    "perfect": {
      "title": "🏆 PERFEITO!",
      "subtitle": "Você gabaritou este quiz!"
    },
    "excellent": {
      "title": "🌟 EXCELENTE!",
      "subtitle": "Ótimo desempenho!"
    },
    "passed": {
      "title": "✅ APROVADO!",
      "subtitle": "Você passou neste quiz!"
    },
    "failed": {
      "title": "❌ REPROVADO",
      "subtitle": "Continue estudando e tente novamente!"
    },
    "correctOf": "{{correct}}/{{total}} questões corretas",
    "passingScore": "Nota Mínima",
    "timeSpent": "Tempo Gasto",
    "correct": "Acertos",
    "pointsEarned": "+{{points}} pontos conquistados!",
    "review": "Revisão das Respostas",
    "question": "Questão {{number}}",
    "answerCorrect": "Correto",
    "answerIncorrect": "Incorreto",
    "yourAnswerBadge": "Sua resposta",
    "yourAnswer": "Sua resposta:",
    "essayNote": "* Questões dissertativas são avaliadas manualmente",
    "explanation": "Explicação",
    "retry": "Tentar Novamente",
    "continue": "Continuar Estudando",
    "noRetries": "Este quiz não permite retentativas. Revise o material e continue seus estudos.",
    "tips": {
      "title": "Dicas para Melhorar",
      "review": "<bold>Revise o material:</bold> Parece que você precisa de mais tempo estudando este conteúdo. Revisite as aulas e materiais complementares.",
      "almost": "<bold>Quase lá:</bold> Você tem uma boa base, mas pode melhorar. Foque nas áreas onde errou e pratique mais.",
      "goodJob": "<bold>Bom trabalho:</bold> Você domina bem o conteúdo! Com um pouco mais de atenção aos detalhes, pode alcançar a excelência.",
      "time": "<bold>Gestão do tempo:</bold> Você usou quase todo o tempo disponível. Pratique mais para responder com mais agilidade."
    }
  }
}
